ANIMATION_DURATION = 150

App.SmNotificationLimiterComponent = Em.Component.extend
  notifier: Em.inject.service()

  classNames: [ 'sm-notification-limiter' ]
  classNameBindings: [ 'isOpaque' ]
  attributeBindings: [ 'style' ]

  init: ->
    @_super()
    onWindowResize = (-> @notifyPropertyChange('style')).bind(@)
    @set('_onWindowResize', onWindowResize)
    Em.$(window).bind('resize', onWindowResize)

  willDestroyElement: ->
    Em.$(window).unbind('resize', @get('_onWindowResize'))

    $parent = @$().closest('.sm-notification-container')
    $ghost =  @$().clone()
    $parent.append $ghost

    Em.run.later =>
      $ghost.removeClass('is-opaque')

      Em.run.later =>
        $ghost.remove()
      , ANIMATION_DURATION

  didInsertElement: ->
    # Анимация появления
    Ember.run.next =>
      return if @get('isDestroyed')
      @set('isOpaque', true)

    @notifyPropertyChange('style')

  # Используется для анимации
  isOpaque: false

  style: (->
    notifications = @get('notifier.limitedQueue')
    index = notifications.get('length')

    $bar = Em.$('header.navigation-bar')

    outerShift = if $bar.length
      $bar.position().top + $bar.outerHeight()
    else
      0

    viewportHeight = Em.$(window).height() - outerShift
    unitHeight = 85
    unitWidth = 330
    unitsPerColumn = Math.floor(viewportHeight / unitHeight)
    column = Math.floor(index / unitsPerColumn)
    row = index % unitsPerColumn

    return ''.htmlSafe() if index == -1

    # topPx   = outerShift + row * unitHeight + 10
    rightPx = 40

    "bottom: 0; right: #{rightPx}px;".htmlSafe()
  ).property('notifier.limitedQueue.[]')

  actions:
    hideAll: ->
      @get('notifier.queue').clear()
      # @get('notifier').get('queue').forEach (item) =>
      #   @get('notifier.queue').removeObject( item )
      false
